import React from 'react';
import { observer } from 'mobx-react';
import { Button, Form, Input, Modal } from 'antd';
import { EMAIL_FORM_RULE } from '@/constants/rules.constants';

interface ComponentProps {
  handleChangeEmail?: any;
  handleCancel?: any;
}

const ChangeEmailForm = (props: ComponentProps) => {
  const { handleChangeEmail, handleCancel } = props;

  return (
    <Modal
      title="Change Email"
      visible={true}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button
          type="primary"
          form="change-email"
          key="submit"
          htmlType="submit"
        >
          Submit
        </Button>,
        <Button onClick={handleCancel}>Cancel</Button>,
      ]}
    >
      <Form
        name="change-email-form"
        className="form change-email"
        id="change-email"
        onFinish={handleChangeEmail}
      >
        <Form.Item name="email" label="New Email" rules={EMAIL_FORM_RULE}>
          <Input placeholder="Email" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default observer(ChangeEmailForm);
